<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-tieredMenu #menuContextuelItemComponent [popup]="true" [model]="menuContextuelItem" appendTo="body"></p-tieredMenu>

<ng-template #tooltipContent>
	<p>
		Sera utilisé comme emplacement de départ pour les réquisitions, comme emplacement de d'arrivée pour les retours
		et ne sera pas disponible pour les transferts.
	</p>

	<div class="flex flex-column gap-2">
		<div class="flex align-items-center justify-content-between gap-1">
			<span>Réquisitions: </span>
			<div class="flex align-items-center gap-1">
				<i class="pi pi-check" style="color: var(--green-500);"></i>
				<i class="pi pi-arrow-right" style="color: white;"></i>
				<i class="pi pi-times" style="color: var(--red-500);"></i>
			</div>
		</div>
		<div class="flex align-items-center justify-content-between gap-1">
			<span>Retours:</span>
			<div class="flex align-items-center gap-1">
				<i class="pi pi-times" style="color: var(--red-500);"></i>
				<i class="pi pi-arrow-right" style="color: white;"></i>
				<i class="pi pi-check" style="color: var(--green-500);"></i>
			</div>
		</div>
		<div class="flex align-items-center justify-content-between gap-1">
			<span>Transferts:</span>
			<div class="flex align-items-center gap-1">
				<i class="pi pi-times" style="color: var(--red-500);"></i>
				<i class="pi pi-arrow-right" style="color: white;"></i>
				<i class="pi pi-times" style="color: var(--red-500);"></i>
			</div>
		</div>
	</div>
</ng-template>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<div class="flex align-items-center gap-4 mb-3">
				<div class="flex align-items-center justify-content-center w-6rem h-6rem bg-gray-100 border-round">
					<i class="pi pi-map-marker text-gray-500" style="font-size: 2rem;"></i>
				</div>
				<div class="flex flex-column gap-1">
					<div class="flex align-items-center gap-2">
						<h5 class="my-0">{{emplacement.nom}}</h5>
						<span [class]="'statut ' + emplacement.statut.nom.toLowerCase()">
							{{emplacement.statut.nom}}
						</span>
					</div>
					<div class="flex align-items-center gap-2">
						<span class="text-500">{{emplacement.code}}</span>
						<span *ngIf="emplacement.dateDebut" class="text-500">Date de départ: {{emplacement.dateDebut |
							date:'dd/MM/yyyy'}}</span>
					</div>
				</div>
			</div>

			<p-menubar autoDisplay="false" [model]="menu">
				<p-button
					*ngIf="estAutorise('emplacement_modifier') && modeConsultation() && emplacement.statut.statutId != 2"
					(click)="btnModifier_click()" icon="pi pi-pencil" styleClass="p-button-primary"></p-button>
				<p-button *ngIf="modeAjoutModification()" (onClick)="enregistrerModifications()" label
					icon="pi pi-check" styleClass="p-button-success mr-2">
				</p-button>
				<p-button *ngIf="modeAjoutModification()" (onClick)="annulerModification($event)" icon="pi pi-times"
					styleClass="p-button-secondary"></p-button>
			</p-menubar>
			<p-messages sticky="false" />
		</p-card>
	</div>


</div>


<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<p-tabView [scrollable]="true" orientation="left" [(activeIndex)]="tabIndex"
				(onChange)="surChangementOnglet($event)">
				<p-tabPanel header="Informations générales" leftIcon="pi pi-info-circle">
					<div class="grid">
						<div class="col-12 lg:col-7">
							<div class="grid ">
								<p-panel *ngIf="emplacement.codeProjet" header="Information relatif au projet"
									styleClass="flex flex-column" class="col-12">
									<div>
										<div class="flex align-items-center justify-content-between gap-2">
											<label>Projet:</label>
											<span>{{emplacement.codeProjet?.code}}</span>
										</div>
										<div *ngIf="client">
											<h6 class="mb-2 mt-4">Information du client</h6>

											<div class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Numéro</label>
												<div class="font-medium">{{client?.numero || '-'}}</div>
											</div>

											<div class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Nom</label>
												<div class="font-medium">{{client?.nom || '-'}}</div>
											</div>

											<p-divider align="center">
												<div class="flex align-items-center gap-2 cursor-pointer"
													(click)="afficherAdresseContact = !afficherAdresseContact">
													<span>Adresse du client</span>
													<i
														[class]="afficherAdresseContact ? 'pi pi-angle-up' : 'pi pi-angle-down'"></i>
												</div>
											</p-divider>

											<div *ngIf="afficherAdresseContact"
												class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Adresse</label>
												<div class="font-medium">{{client?.adresse | valeurVide}}</div>
											</div>

											<div *ngIf="afficherAdresseContact"
												class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Ville</label>
												<div class="font-medium">{{client?.ville | valeurVide}}</div>
											</div>

											<div *ngIf="afficherAdresseContact"
												class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Province</label>
												<div class="font-medium">{{client?.province | valeurVide}}</div>
											</div>

											<div *ngIf="afficherAdresseContact"
												class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Code postal</label>
												<div class="font-medium">{{client?.codePostal | valeurVide}}</div>
											</div>

											<p-divider align="center">
												<div class="flex align-items-center gap-2 cursor-pointer"
													(click)="afficherInformationsContact = !afficherInformationsContact">
													<span>Informations de contact</span>
													<i
														[class]="afficherInformationsContact ? 'pi pi-angle-up' : 'pi pi-angle-down'"></i>
												</div>
											</p-divider>

											<div *ngIf="afficherInformationsContact"
												class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Téléphone</label>
												<div class="font-medium">{{client?.telephone | valeurVide}}</div>
											</div>

											<div *ngIf="afficherInformationsContact"
												class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Courriel</label>
												<div class="font-medium">{{client?.email | valeurVide}}</div>
											</div>

											<div *ngIf="afficherInformationsContact"
												class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Fax</label>
												<div class="font-medium">{{client?.fax | valeurVide}}</div>
											</div>

											<div *ngIf="afficherInformationsContact"
												class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Responsable</label>
												<div class="font-medium">{{client?.responsable | valeurVide}}</div>
											</div>

											<div *ngIf="afficherInformationsContact"
												class="flex justify-content-between gap-2 flex-wrap my-1">
												<label>Téléphone du responsable</label>
												<div class="font-medium">{{client?.telephoneResponsable | valeurVide}}
												</div>
											</div>
										</div>
									</div>
								</p-panel>
								<p-panel
									*ngIf="estAutorise('precommande_detail') && !emplacement.indDepart && emplacement.commandeActive"
									header="Dernières commandes" styleClass="h-full flex flex-column"
									class="col-12 lg:col-6">
									<div style="max-height: 400px; overflow-y: auto;">
										@if(commandes === undefined) {
										<div class="flex align-items-center justify-content-center h-full gap-2">
											<p-progressSpinner></p-progressSpinner>
										</div>
										}
										@for(commande of commandes; track commande.itemCommandeId) {
										<div
											class="flex justify-content-between align-items-center flex-wrap gap-2 my-1">
											<span class="statut {{commande.statut.nom | statut}}">
												<bold>{{commande.quantite}}/{{commande.quantiteDemande}} </bold>
												{{commande.statut.nom}}
											</span>
											<span>
												<i class="pi pi-user"></i>
												{{commande.demandeur?.prenom}} {{commande.demandeur?.nom}}
											</span>
										</div>
										<div class="flex align-items-center gap-2 my-2 w-full cursor-pointer"
											(click)="routerService.navigate(['/item', commande.item.itemId])">
											<div *ngIf="commande.item.photoId">
												@defer (on viewport) {
												<app-image-loader [documentId]="commande.item.photoId" [width]="40"
													[height]="40" [title]="commande.item.numero"></app-image-loader>
												}
												@placeholder {
												<div class="flex align-items-center justify-content-center"
													style="height: 40px; width: 40px;">
													<p-skeleton width="40px" height="40px"></p-skeleton>
												</div>
												}
											</div>
											<div class="flex flex-column gap-1">
												<span class="font-medium">{{commande.item.numero}}</span>
												<span class="text-500"
													style="text-wrap: nowrap;">{{commande.item.description}}</span>
											</div>
										</div>
										<span class="text-500 text-sm">{{commande.dateDemande |
											date:'dd/MM/yyyy'}}</span>
										<p-divider></p-divider>
										}
										@empty {
										<div
											class="flex flex-column justify-content-between align-items-center h-full gap-2">
											<p>Aucune commande trouvée</p>
											<p-button label="Passer une commande" icon="pi pi-plus" outlined
												styleClass="w-full mt-2" (click)="passerCommande()"></p-button>
										</div>
										}
									</div>
									<p-button *ngIf="commandes && commandes?.length > 0" label="Voir le tableau complet"
										outlined class="w-full" styleClass="w-full mt-2"
										(click)="tabIndex.set(4)"></p-button>
								</p-panel>
								<p-menu [model]="actions" styleClass="w-full h-full flex flex-column"
									[class]="(estAutorise('precommande_detail') && !emplacement.indDepart && emplacement.commandeActive) ? 'col-12 lg:col-6 flex' : 'col-12 flex'" />
							</div>
						</div>
						<div class="col-12 lg:col-5 relative">
							<a *ngIf="emplacement.adresse?.rue"
								href="https://www.google.com/maps/dir/?api=1&destination={{emplacement.adresse?.numero}}+{{emplacement.adresse?.rue}}+{{emplacement.adresse?.municipalite}}+{{emplacement.adresse?.province}}+{{emplacement.adresse?.pays}}"
								target="_blank" class="m-4 p-button p-button-raised absolute top-0 left-0"
								style="z-index: 1;" pTooltip="Obtenir l'itinéraire">
								<i class="pi pi-directions cursor-pointer text-white" style="font-size: 1rem"></i>
							</a>
							<div #map class="site-map" [style]="{ height: emplacement.adresse?.rue ? '350px' : '0px' }"
								class="mb-2"></div>
							<p-panel header="Adresse principale">
								<div class="flex flex-column gap-2">
									<span *ngIf="modeConsultation()"
										class="font-medium">{{emplacement.adresse.nom}}</span>
									<input *ngIf="!modeConsultation()" id="nom" type="text" pInputText class="w-full"
										[readonly]="modeConsultation()" [(ngModel)]="emplacement.adresse.nom">
									<span *ngIf="modeConsultation()"
										[class]="(themeService.isDarkMode() ? 'bg-gray-800' : 'bg-gray-100') + ' p-2 border-round w-full'">
										<div *ngIf="emplacement.adresse?.rue">
											{{emplacement.adresse.numero}} {{emplacement.adresse.rue}},
											{{emplacement.adresse.municipalite}}, {{emplacement.adresse.province}},
											{{emplacement.adresse.pays}} {{emplacement.adresse.codePostal}}
										</div>
										<div *ngIf="!emplacement.adresse?.rue">Non configurée</div>
										<div *ngIf="emplacement.adresse.telephone" class="mt-2">
											<i class="pi pi-phone mr-2"></i>
											<span>{{emplacement.adresse.telephone}}</span>
										</div>
									</span>
									<p-button *ngIf="!modeConsultation()" icon="pi pi-search" label="Rechercher"
										class="w-full" styleClass="w-full"
										(click)="rechercherAdresse($event)"></p-button>
									<div *ngIf="!modeConsultation()" class="flex flex-column gap-2 mb-2">
										<label for="numero">Numéro civique</label>
										<input id="numero" type="text" pInputText
											[(ngModel)]="emplacement.adresse.numero" class="w-full"
											(ngModelChange)="updateMapMarker()">
									</div>
									<div *ngIf="!modeConsultation()" class="flex flex-column gap-2 mb-2">
										<label for="rue">Rue</label>
										<input id="rue" type="text" pInputText [(ngModel)]="emplacement.adresse.rue"
											class="w-full" (ngModelChange)="updateMapMarker()">
									</div>
									<div *ngIf="!modeConsultation()" class="flex flex-column gap-2 mb-2">
										<label for="municipalite">Municipalité</label>
										<input id="municipalite" type="text" pInputText
											[(ngModel)]="emplacement.adresse.municipalite" class="w-full"
											(ngModelChange)="updateMapMarker()">
									</div>
									<div *ngIf="!modeConsultation()" class="flex flex-column gap-2 mb-2">
										<label for="province">Province</label>
										<input id="province" type="text" pInputText
											[(ngModel)]="emplacement.adresse.province" class="w-full"
											(ngModelChange)="updateMapMarker()">
									</div>
									<div *ngIf="!modeConsultation()" class="flex flex-column gap-2 mb-2">
										<label for="pays">Pays</label>
										<input id="pays" type="text" pInputText [(ngModel)]="emplacement.adresse.pays"
											class="w-full" (ngModelChange)="updateMapMarker()">
									</div>
									<div *ngIf="!modeConsultation()" class="flex flex-column gap-2 mb-2">
										<label for="codePostal">Code postal</label>
										<input id="codePostal" type="text" pInputText
											[(ngModel)]="emplacement.adresse.codePostal" class="w-full"
											(ngModelChange)="updateMapMarker()">
									</div>
									<div *ngIf="!modeConsultation()" class="flex flex-column gap-2 mb-2">
										<label for="telephone">Téléphone du site</label>
										<input id="telephone" type="text" pInputText
											[(ngModel)]="emplacement.adresse.telephone" class="w-full"
											(ngModelChange)="updateMapMarker()">
									</div>
								</div>
							</p-panel>
							<p-panel header="Adresses additionnelles" styleClass="my-2">
								<ng-template pTemplate="icons">
									<button *ngIf="estAutorise('emplacement_modifier') && modeConsultation()" pButton
										pRipple icon="pi pi-plus"
										class="p-button-text p-button-rounded p-button-success"
										pTooltip="Ajouter une adresse" (click)="ouvrirDialogueAjouterAdresse()">
									</button>
								</ng-template>

								<div *ngIf="chargementAdresses" class="text-center">
									<p-progressSpinner></p-progressSpinner>
								</div>

								<div *ngIf="!chargementAdresses && adressesEmplacement.length === 0"
									class="text-center text-500">
									<p>Aucune adresse additionnelle configurée</p>
								</div>

								<div *ngIf="!chargementAdresses && adressesEmplacement.length > 0"
									class="flex flex-column gap-2" style="max-height: 300px; overflow-y: auto;">
									<div *ngFor="let adresseEmp of adressesEmplacement">
										<div class="flex justify-content-between align-items-center">
											<h6 class="m-0">{{adresseEmp.adresse.nom || 'Adresse sans nom'}}</h6>
											<div class="flex gap-1"
												*ngIf="estAutorise('emplacement_modifier') && modeConsultation()">
												<button pButton pRipple icon="pi pi-trash"
													class="p-button-text p-button-rounded p-button-sm p-button-danger"
													pTooltip="Supprimer"
													(click)="confirmerSupprimerAdresse(adresseEmp)">
												</button>
											</div>
										</div>

										<div class="flex flex-column gap-2 text-sm">
											<span
												[class]="(themeService.isDarkMode() ? 'bg-gray-800' : 'bg-gray-100') + ' p-2 border-round w-full'">
												<div>
													{{adresseEmp.adresse.numero}} {{adresseEmp.adresse.rue}},
													{{adresseEmp.adresse.municipalite}},
													{{adresseEmp.adresse.province}},
													{{adresseEmp.adresse.pays}} {{adresseEmp.adresse.codePostal}}
												</div>
												<div *ngIf="adresseEmp.adresse.telephone" class="mt-2">
													<i class="pi pi-phone mr-2"></i>
													<span>{{adresseEmp.adresse.telephone}}</span>
												</div>
											</span>
										</div>

										<ng-template pTemplate="footer">
											<div class="flex justify-content-between align-items-center">
												<small class="text-500">
													Ajoutée le {{adresseEmp.dateCreation | date:'dd/MM/yyyy'}}
												</small>
												<a *ngIf="adresseEmp.adresse.numero && adresseEmp.adresse.rue && adresseEmp.adresse.municipalite"
													href="https://www.google.com/maps/dir/?api=1&destination={{adresseEmp.adresse.numero}}+{{adresseEmp.adresse.rue}}+{{adresseEmp.adresse.municipalite}}+{{adresseEmp.adresse.province}}+{{adresseEmp.adresse.pays}}"
													target="_blank" pTooltip="Obtenir l'itinéraire"
													class="p-button p-button-outlined p-button-rounded p-button-sm cursor-pointer">
													<i class="pi pi-directions"></i>
												</a>
											</div>
										</ng-template>
										<p-divider></p-divider>
									</div>
								</div>
							</p-panel>
						</div>
					</div>
					<p-panel *ngIf="emplacement.adresse?.rue" header="Prévision météo">
						<app-prevision-meteo [emplacementId]="emplacement.emplacementId"></app-prevision-meteo>
					</p-panel>
				</p-tabPanel>
				<p-tabPanel *ngIf="estAutorise('emplacement_inventaire') " header="Inventaire" leftIcon="pi pi-list">
					<ng-template pTemplate="content">
						<p-menu #menuContextuelInventaire popup="popup"
							[model]="contenuMenuContextuelInventaire"></p-menu>
						<div class="mb-4">
							<h5 class="my-1">Inventaire</h5>
							<span class="text-500">Liste des items d'inventaire associés à cet emplacement ou à un
								employé de ce projet.</span>
						</div>
						<div class="flex align-items-center justify-content-between my-2">
							<div class="flex gap-2">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text"
										(input)="dtInventaire.filterGlobal($event.target.value, 'contains')"
										placeholder="Recherche..." />
								</span>
								<button pButton pRipple icon="pi pi-sliders-h" pTooltip="Afficher les filtres avancés"
									class="p-button-outlined" (click)="afficherFiltresAvances = true"></button>


							</div>
							<div class="flex gap-2">
								<button pButton pRipple icon="pi pi-file-pdf" class="p-button-primarys"
									(click)="exportExcel()" pTooltip="Exporter en Excel"></button>
								<p-multiSelect [options]="colonnesDisponibles" [(ngModel)]="selectedColumns"
									optionLabel="entete" (onChange)="surChangementColonnes($event)"
									selectedItemsLabel="{0} colonnes sélectionnés" [style]="{minWidth: '200px'}"
									placeholder="Colonnes..."></p-multiSelect>
							</div>
						</div>
						<p-table #dtInventaire [value]="inventaire" dataKey="itemId" [lazy]="true"
							[totalRecords]="totalInventaire" tableStyleClass="tableNormale" autoLayout="true"
							styleClass="p-datatable-sm p-datatable-striped" [rows]="100" [paginator]="true"
							[rowsPerPageOptions]="[10,25,50,100,500]"
							[loading]="!chargementCompleteInventaire || !inventaire" [rowHover]="true" [filterDelay]="0"
							[globalFilterFields]="['numero','quantite','description']"
							(onLazyLoad)="onLazyLoadInventaire($event)">
							<ng-template pTemplate="header">
								<tr>
									<th></th>
									<th pSortableColumn="numero">
										<div class="flex justify-content-between align-items-center">
											Numéro
											<p-sortIcon field="numero"></p-sortIcon>
											<p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="description">
										<div class="flex justify-content-between align-items-center">
											Description
											<p-sortIcon field="description"></p-sortIcon>
											<p-columnFilter type="text" field="description" display="menu"
												class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="statut.nom">
										<div class="flex justify-content-between align-items-center">
											Statut
											<p-sortIcon field="statut.nom"></p-sortIcon>
											<p-columnFilter field="statut.statutId" matchMode="in" display="menu"
												[showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
												<ng-template pTemplate="filter" let-value let-filter="filterCallback">
													<p-multiSelect [ngModel]="value" [options]="statuts"
														placeholder="Any" (onChange)="filter($event.value)"
														optionLabel="nom" optionValue="statutId">
													</p-multiSelect>
												</ng-template>
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="EstColonneSelectionnee('categorie')" pSortableColumn="categorie.nom">
										<div class="flex justify-content-between align-items-center">
											Catégorie
											<p-sortIcon field="categorie.nom"></p-sortIcon>
											<p-columnFilter field="categorie.categorieId" matchMode="in" display="menu"
												[showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
												<ng-template pTemplate="filter" let-value let-filter="filterCallback">
													<p-multiSelect [ngModel]="value" [options]="categories"
														placeholder="Any" (onChange)="filter($event.value)"
														optionLabel="nom" optionValue="categorieId">
													</p-multiSelect>
												</ng-template>
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="EstColonneSelectionnee('sousCategorie')"
										pSortableColumn="sousCategorie.nom">
										<div class="flex justify-content-between align-items-center">
											Sous-catégorie
											<p-sortIcon field="sousCategorie.nom"></p-sortIcon>
											<p-columnFilter field="sousCategorie.sousCategorieId" matchMode="in"
												display="menu" [showMatchModes]="false" [showOperator]="false"
												[showAddButton]="false">
												<ng-template pTemplate="filter" let-value let-filter="filterCallback">
													<p-multiSelect [ngModel]="value" [options]="sousCategories"
														placeholder="Any" (onChange)="filter($event.value)"
														optionLabel="nom" optionValue="sousCategorieId">
													</p-multiSelect>
												</ng-template>
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="EstColonneSelectionnee('marque')" pSortableColumn="marque">
										<div class="flex justify-content-between align-items-center">
											Marque
											<p-sortIcon field="marque"></p-sortIcon>
											<p-columnFilter type="text" field="marque" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="EstColonneSelectionnee('modele')" pSortableColumn="modele">
										<div class="flex justify-content-between align-items-center">
											Modèle
											<p-sortIcon field="modele"></p-sortIcon>
											<p-columnFilter type="text" field="modele" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="EstColonneSelectionnee('noCtrl')" pSortableColumn="noCtrl">
										<div class="flex justify-content-between align-items-center">
											No Ctrl
											<p-sortIcon field="noCtrl"></p-sortIcon>
											<p-columnFilter type="text" field="noCtrl" display="menu" class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="EstColonneSelectionnee('compagnie')" pSortableColumn="compagnie.nom">
										<div class="flex justify-content-between align-items-center">
											Compagnie
											<p-sortIcon field="compagnie.nom"></p-sortIcon>
											<p-columnFilter field="compagnie.compagnieId" matchMode="in" display="menu"
												[showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
												<ng-template pTemplate="filter" let-value let-filter="filterCallback">
													<p-multiSelect [ngModel]="value" [options]="filtreCompagnies"
														placeholder="Any" (onChange)="filter($event.value)"
														optionLabel="nom" optionValue="compagnieId">
													</p-multiSelect>
												</ng-template>
											</p-columnFilter>
										</div>
									</th>
									<th pSortableColumn="quantite">
										<div class="flex justify-content-between align-items-center">
											Quantité
											<p-sortIcon field="quantite"></p-sortIcon>
											<p-columnFilter type="numeric" field="quantite" display="menu"
												class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<th *ngIf="EstColonneSelectionnee('dateArriveEnChantier')"
										pSortableColumn="dateArriveEnChantier">
										<div class="flex justify-content-between align-items-center">
											Date d'arrivée en chantier
											<p-sortIcon field="dateArriveEnChantier"></p-sortIcon>
											<p-columnFilter type="date" field="dateArriveEnChantier" display="menu"
												class="ml-auto">
											</p-columnFilter>
										</div>
									</th>
									<ng-container *ngFor="let col of colonnesSelectionnees">
										<th *ngIf="!col.base">
											<div class="flex justify-content-between align-items-center">
												{{col.entete}}
											</div>
										</th>
									</ng-container>

									<th style="min-width: 9rem; max-width: 9rem"></th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-item>

								<tr>
									<td>
										<div *ngIf="item.photoId">
											@defer (on viewport) {
											<app-image-loader [documentId]="item.photoId" [width]="40" [height]="40"
												[title]="item.numero"></app-image-loader>
											}
											@placeholder {
											<div class="flex align-items-center justify-content-center"
												style="height: 40px; width: 40px;">
												<p-skeleton width="40px" height="40px"></p-skeleton>
											</div>
											}
										</div>
									</td>
									<td>
										<div class="flex align-items-center gap-2">
											<a [routerLink]="'/item/' + item.itemId"
												class="text-primary hover:underline">{{item.numero}}</a>
										</div>
									</td>
									<td><i *ngIf="item.produitDangereux"
											class="pi pi-exclamation-triangle text-yellow-500 mr-2"
											pTooltip="Produit Dangereux"></i> {{item.description}}</td>
									<td><span [class]="'statut ' + item.statut.nom.toLowerCase()">
											{{item.statut.nom}}
										</span>
									</td>
									<td *ngIf="EstColonneSelectionnee('categorie')">
										{{item.categorie.nom}}
									</td>
									<td *ngIf="EstColonneSelectionnee('sousCategorie')">
										{{item.sousCategorie?.nom}}
									</td>
									<td *ngIf="EstColonneSelectionnee('marque')">
										{{item.marque}}
									</td>
									<td *ngIf="EstColonneSelectionnee('modele')">
										{{item.modele}}
									</td>
									<td *ngIf="EstColonneSelectionnee('noCtrl')">
										{{item.noCtrl}}
									</td>
									<td *ngIf="EstColonneSelectionnee('compagnie')">
										<app-compagnie-label [compagnie]="item.compagnie"></app-compagnie-label>
									</td>
									<td>{{item.quantite}}</td>
									<td *ngIf="EstColonneSelectionnee('dateArriveEnChantier')">
										@if (item.categorie.estUnique) {
										{{item.dateArriveEnChantier | date:'dd/MM/yyyy' | valeurVide}}
										} @else {
										<span class="text-500">N/A</span>
										}
									</td>
									<ng-container *ngFor="let col of colonnesSelectionnees">
										<td *ngIf="!col.base">
											{{obtenirValeurAttribut(item, col.champ)}}
										</td>
									</ng-container>
									<td>
										<button *ngIf="estAutorise('item_detail')" pButton pRipple
											icon="pi pi-external-link" class="p-button-secondary mr-2 boutonGrille"
											(click)="OuvrirDetailItemNouvelOnglet(item.itemId)"></button>
										<button pButton pRipple icon="pi pi-eye" pTooltip="Voir"
											class="p-button-success mr-2 boutonGrille"
											[routerLink]="'/item/' + item.itemId"
											(mouseenter)="surMenuContextuelItem($event, item)"></button>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="9">
										<div class="flex justify-content-center align-items-center"
											style="min-height: 100px;">
											<span class="text-500"><i class="pi pi-info-circle mr-2"></i>Aucun résultat
												trouvé.</span>
										</div>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="loadingicon">
								<div class="flex flex-column gap-2 my-2 col-12 text-center">
									<p-progressSpinner></p-progressSpinner>
								</div>
							</ng-template>
						</p-table>
					</ng-template>
				</p-tabPanel>

				<p-tabPanel *ngIf="emplacement.statut.statutId != 2" header="Membres" leftIcon="pi pi-users">
					<p-menu #menuContextuelInventaire popup="popup" [model]="contenuMenuContextuelInventaire"></p-menu>

					<p-card *ngIf="!membres">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>
					<div *ngIf="membres" class="mb-4">
						<h5 class="my-1">Membres</h5>
						<span class="text-500">Vous trouverez ici la liste des membres associés à cet emplacement et
							leurs responsabilités.</span>
					</div>
					<div *ngIf="membres" class="flex align-items-center justify-content-between my-2">
						<div class="flex gap-2">
							<span class="p-input-icon-left">
								<i class="pi pi-search"></i>
								<input pInputText type="text"
									(input)="dtMembres.filterGlobal($event.target.value, 'contains')"
									placeholder="Recherche..." />
							</span>
							<button *ngIf="estAutorise('emplacement_modifier')" pButton pRipple icon="pi pi-plus"
								class="p-button-success" label="Ajouter" (click)="ajouterMembre()"
								pTooltip="Ajouter un membre"></button>
						</div>
					</div>
					<p-table *ngIf="membres" #dtMembres [value]="membres" dataKey="membreEmplacementId"
						tableStyleClass="tableNormale" autoLayout="true" styleClass="p-datatable-sm p-datatable-striped"
						[rowHover]="true" [filterDelay]="0" [globalFilterFields]="['employe.nom','employe.prenom','employe.courriel']">
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="employe.prenom">
									<div class="flex justify-content-between align-items-center">
										Prénom
										<p-sortIcon field="employe.prenom"></p-sortIcon>
										<p-columnFilter type="text" field="employe.prenom" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="employe.nom">
									<div class="flex justify-content-between align-items-center">
										Nom
										<p-sortIcon field="employe.nom"></p-sortIcon>
										<p-columnFilter type="text" field="employe.nom" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="employe.courriel">
									<div class="flex justify-content-between align-items-center">
										Courriel
										<p-sortIcon field="employe.courriel"></p-sortIcon>
										<p-columnFilter type="text" field="employe.courriel" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th>Attributs</th>
								<th style="min-width: 5rem; width: 5rem"></th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-membre>
							<tr>
								<td>{{membre.employe.prenom}}</td>
								<td>{{membre.employe.nom}}</td>
								<td>{{membre.employe.courriel}}</td>
								<td>
									<div class="flex flex-wrap gap-2">
										<p-tag *ngIf="membre.indChargeProjet" value="Chargé de projet"
											severity="success"></p-tag>
										<p-tag *ngIf="membre.indResponsable" value="Responsable"
											severity="info"></p-tag>
										<p-tag *ngIf="membre.indReceptionRapportJournalier"
											value="Reception de rapports journaliers" severity="warning"></p-tag>
										<p-tag *ngIf="membre.indReceptionPriseHeures"
											value="Reception de prise des heures/kms" severity="warning"></p-tag>
										@if (membre.indReceptionEntreesSorties) {
											<p-tag value="Réception entrées/sorties" severity="warning"></p-tag>
										}
										<p-tag *ngIf="membre.indSst" value="Responsable SST" severity="danger"></p-tag>
										<p-tag *ngIf="membre.indAjoutAuto" value="Emplacement réel (Division)"
											severity="success"></p-tag>
									</div>
								</td>
								<td>
									<div class="flex gap-2">
										<button *ngIf="estAutorise('emplacement_modifier')" pButton pRipple
											icon="pi pi-pencil" class="p-button-secondary boutonGrille"
											(click)="modifierAttributsMembre(membre)"></button>
										<button *ngIf="estAutorise('emplacement_modifier')" pButton pRipple
											icon="pi pi-trash" class="p-button-danger boutonGrille"
											(click)="supprimerMembre(membre.employe)"></button>
									</div>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="6">
									<div class="flex justify-content-center align-items-center"
										style="min-height: 100px;">
										<span class="text-500"><i class="pi pi-info-circle mr-2"></i>Aucun membre
											associé à cet emplacement.</span>
									</div>
								</td>
							</tr>
						</ng-template>
					</p-table>
					<div *ngIf="travailleurs" class="my-4">
						<h5 class="my-1">Travailleurs</h5>
						<span class="text-500">Vous trouverez ici la liste des travailleurs associés à cet emplacement.</span>
					</div>
					<p-table *ngIf="travailleurs" #dtTravailleurs [value]="travailleurs" dataKey="membreEmplacementId"
						tableStyleClass="tableNormale" autoLayout="true" styleClass="p-datatable-sm p-datatable-striped"
						[rowHover]="true" [filterDelay]="0" [globalFilterFields]="['employe.nom','employe.prenom','employe.courriel']">
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="employe.prenom">
									<div class="flex justify-content-between align-items-center">
										Prénom
										<p-sortIcon field="employe.prenom"></p-sortIcon>
										<p-columnFilter type="text" field="employe.prenom" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="employe.nom">
									<div class="flex justify-content-between align-items-center">
										Nom
										<p-sortIcon field="employe.nom"></p-sortIcon>
										<p-columnFilter type="text" field="employe.nom" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-membre>
							<tr>
								<td>{{membre.employe.prenom}}</td>
								<td>{{membre.employe.nom}}</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="6">
									<div class="flex justify-content-center align-items-center"
										style="min-height: 100px;">
										<span class="text-500"><i class="pi pi-info-circle mr-2"></i>Aucun travailleur
											associé à cet emplacement.</span>
									</div>
								</td>
							</tr>
						</ng-template>
					</p-table>
				</p-tabPanel>

				<p-tabPanel [header]="'Documents (' + emplacement.nombreDocuments + ')'" leftIcon="pi pi-file">
					<ng-template pTemplate="content">
						<app-document [typeLienDocument]="ETypeLienDocument.Emplacement"
							[idLien]="emplacement.emplacementId" [numero]="emplacement.code"></app-document>
					</ng-template>
				</p-tabPanel>
				<p-tabPanel
					*ngIf="estAutorise('precommande_detail') && !emplacement.indDepart && emplacement.commandeActive"
					header="Commandes" leftIcon="pi pi-shopping-cart">
					<ng-template pTemplate="content">
						<app-detail-commande [emplacementId]="emplacement.emplacementId"
							[modeStandard]="false" ></app-detail-commande>
					</ng-template>
				</p-tabPanel>

				<!-- Parameters Tab -->
				<p-tabPanel *ngIf="estAutorise('emplacement_modifier')" header="Paramètres" leftIcon="pi pi-cog">
					<ng-template pTemplate="content">
						<div class="grid">
							<div class="col-12">
								<p-card>
									<h6 class="mb-4 text-primary-600 font-semibold">Configuration de l'emplacement</h6>
									<div class="flex flex-column gap-4">
										<div class="flex flex-column gap-2">
											<div class="grid">
												<div class="col-12 md:col-6 flex flex-column gap-2">
													<label for="indDepart" class="font-medium">
														Nom du site
													</label>
													<small class="text-500">
														Nom descriptif lié à l'emplacement géographique.
													</small>
												</div>
												<div class="col-12 md:col-6">
													<input id="nom" type="text" pInputText [(ngModel)]="emplacement.nom"
														class="w-full" [disabled]="modeConsultation()">
													<small class="p-error" *ngIf="submitted && !emplacement.nom">Le nom
														du site est obligatoire.</small>
												</div>
												<div class="col-12 md:col-6 flex flex-column gap-2">
													<label for="indDepart" class="font-medium">
														Code du site
													</label>
													<small class="text-500">
														Code séquentiel unique identifiant l'emplacement géographique.
													</small>
												</div>
												<div class="col-12 md:col-6">
													<input id="code" type="text" pInputText
														[(ngModel)]="emplacement.code" class="w-full"
														[disabled]="modeConsultation()">
													<small class="p-error" *ngIf="submitted && !emplacement.code">Le
														code du site est obligatoire.</small>
												</div>
												<div class="col-12 md:col-6 flex flex-column gap-2">
													<label for="indDepart" class="font-medium">
														Projet
													</label>
													<small class="text-500">
														Projet CTRL associé à cet emplacement. Doit refléter le code de
														projet.
													</small>
												</div>
												<div class="col-12 md:col-6">
													<p-dropdown #champCodeActivite [disabled]="modeConsultation()"
														[options]="codesProjet" [(ngModel)]="emplacement.codeProjet"
														optionLabel="code" [showClear]="true" filter="true"
														filterBy="code,nom" appendTo="body" styleClass="w-full"
														class="w-full"
														placeholder="Sélectionner un code de projet Ctrl...">
														<ng-template pTemplate="selectedItem">
															<div *ngIf="emplacement.codeProjet">
																<div>{{emplacement.codeProjet.code}} -
																	{{emplacement.codeProjet.nom}}
																</div>
															</div>
														</ng-template>
														<ng-template let-code pTemplate="item">
															<div>
																<div>{{code.code}} - {{code.nom}}</div>
															</div>
														</ng-template>
													</p-dropdown>
												</div>
												<div class="col-12 md:col-6 flex flex-column gap-2">
													<label for="indDepart" class="font-medium">
														Emplacement de départ
														<i class="pi pi-info-circle ml-2" [pTooltip]="tooltipContent"
															[tooltipPosition]="'bottom'"></i>
													</label>
													<small class="text-500">
														Sera utilisé comme emplacement de départ pour les réquisitions,
														comme emplacement d'arrivée pour les retours et ne sera pas
														disponible pour les transferts.
													</small>
												</div>
												<div class="col-12 md:col-6">
													<p-selectButton [options]="[
															{label: 'Oui', value: true},
															{label: 'Non', value: false}
														]" [(ngModel)]="emplacement.indDepart" inputId="indDepart" [disabled]="modeConsultation()">
													</p-selectButton>
												</div>
												<div class="col-12 md:col-6 flex flex-column gap-2">
													<label for="dateDebut">Date de début</label>
													<small class="text-500">
														Date de début du projet associé à cet emplacement. Visible dans
														le rapport SST.
													</small>
												</div>
												<div class="col-12 md:col-6">
													<p-calendar id="dateDebut" [disabled]="modeConsultation()"
														[(ngModel)]="emplacement.dateDebut">
													</p-calendar>
												</div>
											</div>
										</div>
									</div>
								</p-card>
							</div>
						</div>
					</ng-template>
				</p-tabPanel>
			</p-tabView>
		</p-card>
	</div>


</div>

<!-- 

<p-dialog [(visible)]="dialogueAjustementInventaire" [style]="{width: '40%'}" header="Ajustement d'inventaire"
	[modal]="true" [contentStyle]="{'overflow': 'visible'}" styleClass="fluid formgrid grid">
	<ng-template pTemplate="content">

		<div class="formgrid grid">
			<div class="flex flex-column gap-2 my-2 col-12 lg:col-8">
				<label for="noFournisseur">Quantité</label>
				<p-inputNumber id="noFournisseur">
				</p-inputNumber>
			</div>
		</div>

	</ng-template>

	<ng-template pTemplate="footer">
		<button pButton pRipple label="Annuler" icon="pi pi-times" class="p-button-text"
			(click)="hideDialog()"></button>
		<button pButton pRipple label="Ajuster" icon="pi pi-check" class="p-button-text"
			(click)="ajusterInventaire()"></button>
	</ng-template>
</p-dialog> -->

<p-sidebar [(visible)]="afficherDetailItem" [style]="{width:'95%'}" position="left">
	<app-detail-item [itemId]="detailItemId" *ngIf="afficherDetailItem"></app-detail-item>
</p-sidebar>

<p-sidebar [(visible)]="afficherFiltresAvances" [style]="{width:'30em'}" position="right" [blockScroll]="true">
	<ng-template pTemplate="header">
		<h3>Filtres avancés</h3>
	</ng-template>

	<app-filtres-avances [(filtres)]="filtres" [filterConfigs]="filterConfigs"
		[table]="tableInventaire"></app-filtres-avances>

	<ng-template pTemplate="footer">
		<div class="flex justify-content-end gap-2">
			<p-button label="Réinitialiser" icon="pi pi-refresh" (onClick)="reinitialiserFiltres()"
				styleClass="p-button-outlined"></p-button>
			<p-button label="Fermer" icon="pi pi-times" (onClick)="afficherFiltresAvances = false"></p-button>
		</div>
	</ng-template>
</p-sidebar>